export default(state={theme:""}, payload) => {
    switch(payload.type) {
        case 'APP_THEME':
            console.log(payload);
            return {theme:payload.theme}; 
        default:
            return state;
    }
}